
<template>
    <div id="app" class="app fond">
       <div class="DivImageHautPage">
            <img :src="actualite.acf.image" class="imageHautPage" :alt="'Image'+actualite.acf.titre">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{actualite.acf.titre}}</h1>
                </section>
                <div class="button">
                    <router-link to="/agenda">Retourner sur toutes les actualités</router-link>
                </div>
                <section class="Section-pages">
                    <section>
                        <div class="Fiche" >
                            <div class="Infos Contact">
                                <p class="paragraphe" v-html="actualite.acf.texte"></p>
                                <!-- <img :src="actualite.acf.image_text" style="width: 50%; min-width: 300px; border-radius: 20px; margin: 0 auto; height: auto" :alt="actualite.acf.nom"> -->
                            </div>
                            <div class="contenu-droit-page" >
                                <img v-if="actualite.acf.type_fichier === 'Image'" :src="actualite.acf.image_text" :alt="actualite.acf.nom">
                                <iframe v-else :src="actualite.acf.image_text" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                    </section>
                    <br>
                    <h3 v-if="actualite.acf.album != ''">Album photo</h3>
                    <router-link v-for="album in listeAlbums" :key="album.id" :to="{name: 'EnImage', params: {id : album.id}}">
                        <div class="pochette-Album" v-if="album.id == actualite.acf.album">
                            <div class="derniereSlide">
                                <img :src="album.images[2].url" alt="">
                            </div>
                            <div class="secondeSlide">
                                <img :src="album.images[1].url" alt="">
                            </div>
                            
                            <div class="premiereSlide">
                                <img :src="album.images[0].url" alt="">
                            </div>
                            <div class="Titre-Album">
                                <h5>{{album.titre_album}}</h5>
                            </div>
                        </div>
                    </router-link>
                </section>
            </section>
           
        </div>
    </div>
</template>

<script>


import param from '@/param/param'

export default {
    name: 'Publication',
    data () {
        return{
            actualite:{
                id: 0,
                acf:{
                    titre: null,
                    date: null,
                    fichier_pdf: null
                }
            },

            listeAlbums:{
                id:0,
                titre_album: null,
                date_de_debut:null,
                date_de_fin: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                images:{
                    id: 0,
                    url: null,
                    title: null
                }
            },
            listeActualites:{
                id: 0,
                titre: null,
                texte: null,
                date: null,
                mots_cles:{
                    term_id:0,
                    name:null
                },
                image: null,
                album: 0
            },
        }

    }, 

    created(){
        this.actualite.id = this.$route.params.id;
        console.log('id actu', this.actualite.id);

        axios.get(param.hostacf+"actualites/" + this.actualite.id)
        .then(response=>{
            this.actualite = response.data;
            console.log('actualite', this.actualite)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'album/v1/listeAlbums')
        .then(response =>{
        this.listeAlbums = response.data;
            console.log('listeAlbums', this.listeAlbums)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'actualite/v1/listeActualites')
        .then(response =>{
            this.listeActualites = response.data;
            let actu = new Array
            let j = 0
            for(var i = 0; this.listeActualites.length > i; i++){
                this.dateSplit = this.listeActualites[i].date.split('/');
                this.listeActualites[i].date_comparaison = this.dateSplit[2]+'-'+this.dateSplit[1]+'-'+this.dateSplit[0];
                
                if(this.listeActualites[i].id > this.actualite.id){
                    actu[j] = this.listeActualites[i]
                    j++;
                }
            }
            
            this.listeActualitesFuture = actu;
            console.log('actu', actu, 'listeActuFuture', this.listeActualitesFuture);
        })
    },
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Publication.vue